import autoBind         from 'react-autobind';
import React            from 'react';
import TimelineActivity from '~/components/drawers/timeline/activity';

const TimelineActivityDeleteJob = ({
  icon = 'briefcase',
  prefix = 'far',
  color = 'text-grey-dark',
  title = (obj) => {
    const { activity } = obj.props;
    const { job_title, location, deleted_by } = activity.parameters || {};

    return (
      `${job_title} Job${location ? ` in ${location}` : ''} was deleted${deleted_by ? ` by ${deleted_by}` : ''}`
    );
  },
  ...props
}) => <TimelineActivity {...props} icon={icon} prefix={prefix} color={color} title={title} />;

export default TimelineActivityDeleteJob;
